import { GridColTypeDef } from '@mui/x-data-grid-pro'
import { format } from 'date-fns'
import {
  getGridMultiDateOperators,
  getGridMultiNumberOperators,
  getGridMultiValueOperators,
} from './filterOperators'
import {
  renderHoverFullContentCell,
  renderHoverFullContentCellNewLine,
  renderHoverFullContentCellDateNewLine,
  renderHoverFullContentCellStringNewLine,
} from './renderCells/HoverFullContentCell'
import {
  gridStringOrNumberArrayComparator,
  gridEnhancedSortComparator,
  gridDateArrayComparator,
  SortOnProperty,
} from './sortComparators'
import { EnhancedSortHeader } from './enhancedSort/EnhancedSortHeader'
import { type EnhancedSortRef } from './enhancedSort/EnhancedSortHOC'

export const multiValueSelect: GridColTypeDef<string[], string> = {
  type: 'singleSelect',
  filterOperators: getGridMultiValueOperators(),
  /** 
   render cell takes precedence over valueFormatter, but valueFormatter is used for csv export
   this is also used to format the column.valueOptions (not mentioned in their docs)
   there is a weird typescript bug with MUI, where it expects the column.valueOptions to be the same datatype as the cell value
   which is not the case with this multiValueSelect. Option is a string where value is an array of strings
  * */
  valueFormatter: ({ value }) => {
    if (Array.isArray(value)) {
      return value.join(', ')
    }
    return value
  },
  renderCell: renderHoverFullContentCell,
  sortComparator: gridStringOrNumberArrayComparator(),
}

export const multiValueSelectNewLine: GridColTypeDef<string[], string> = {
  type: 'singleSelect',
  filterOperators: getGridMultiValueOperators(),

  valueFormatter: ({ value }) => {
    if (Array.isArray(value)) {
      return value.join(', ')
    }
    return value
  },
  renderCell: renderHoverFullContentCellNewLine,
  sortComparator: gridStringOrNumberArrayComparator(),
}

export const multiDateColumn: GridColTypeDef<
  Array<Date | null | undefined> | null | undefined,
  any
> = {
  type: 'date',
  // @ts-ignore
  filterOperators: getGridMultiDateOperators(),
  /** used for download */
  valueFormatter: ({ value }) => {
    return (
      value?.map((dt) => (dt ? format(dt, 'MM/dd/yyyy') : '')).join(', ') || ''
    )
  },
  renderCell: renderHoverFullContentCellDateNewLine,
  sortComparator: gridDateArrayComparator(),
}

export const multiStringColumn: GridColTypeDef<Array<String>, any> = {
  type: 'string',
  // @ts-ignore
  filterOperators: getGridMultiValueOperators(),
  /** used for download */
  valueFormatter: ({ value }) => {
    return value?.join(', ') || ''
  },
  renderCell: renderHoverFullContentCellStringNewLine,
  sortComparator: gridStringOrNumberArrayComparator(),
}

export const multiNumberColumnNewLine: GridColTypeDef<
  Array<number | null | undefined> | null | undefined,
  any
> = {
  type: 'number',
  // @ts-ignore
  filterOperators: getGridMultiNumberOperators(),
  /** used for download */
  valueFormatter: ({ value }) => {
    return value?.join(', ') || ''
  },
  renderCell: renderHoverFullContentCellNewLine,
  sortComparator: gridStringOrNumberArrayComparator(),
}

export function enhancedSortColumn<T extends {}>(
  sortRef: EnhancedSortRef,
  /** if the array values are an object, use this callback to access the property you want to sort on, an empty array will pass undefined to the property getter */
  sortPropertyGetter?: SortOnProperty<T>,
) {
  return {
    sortable: false,
    renderHeader: EnhancedSortHeader,
    sortComparator: gridEnhancedSortComparator(sortRef, sortPropertyGetter),
  }
}
